import { left, right } from 'fp-ts/Either';

import { httpClientFunction } from 'domain/types';
import Layout, { WidgetLayout } from 'domain/entity/layout';
import UpdateLayoutClient from 'use-case/layout/update/updateLayoutClient';
import UpdateLayoutCriteria from 'use-case/layout/update/updateLayoutCriteria';

const updateLayoutApiClient = (httpClient: httpClientFunction, baseUrl: string): UpdateLayoutClient => (criteria: UpdateLayoutCriteria) =>
    httpClient(`${baseUrl}/dashboards/dashboards/${criteria.dashboardId}/layouts/${criteria.layout.type}`, {
        method: 'PUT',
        body: JSON.stringify(asLayoutToUpdate(criteria.layout)),
        headers: { 'Content-Type': 'application/json' },
    })
        .then((response) =>
            response.ok
                ? response
                      .json()
                      .then((json: { type: string }) => ({ id: json.type }))
                      .then(right)
                      .catch(() => left({ error: new Error(), status: 500 }))
                : left({ error: new Error(), status: response.status })
        )
        .catch(() => left({ error: new Error(), status: 503 }));

const asLayoutToUpdate = (layout: Layout): jsonUpdateTemplate => ({
    type: layout.type,
    widgets: layout.widgets.map((widgetLayout: WidgetLayout) => ({
        id: widgetLayout.id,
        position: { x: widgetLayout.position.x, y: widgetLayout.position.y },
        size: { width: widgetLayout.size.width, height: widgetLayout.size.height },
    })),
});

type jsonUpdateTemplate = {
    type: string;
    widgets: { id: string; position: { x: number; y: number }; size: { width: number; height: number } }[];
};

export default updateLayoutApiClient;
